import {
    ExportColumnId,
    exportColumnHeadingBundle,
    exportColumnHeadingKey,
    HeaderRowMode,
    UnitPlacement,
} from '../shared/models/export-columns.model';
import {ExportFileFormat} from '../shared/models/export-file-format.model';
import {SavedExportOutputFormat} from '../shared/models/output-format.model';
import {
    FilePreviewColumn,
    FilePreviewSample,
    sampleMeters,
    sampleTextColumns,
} from './exported-value.model';
import {
    buildCsvPreview,
    buildExcelPreview,
    buildJsonPreview,
    FilePreviewContent,
} from './file-preview.model';

export type PreviewTranslate = (key: string, application: string, module: string) => string;

export type PreviewColumnChoice = {id: ExportColumnId; header: string | null};

export type PreviewShape = {
    columns: ReadonlyArray<PreviewColumnChoice>;
    headerRow: HeaderRowMode;
    unitPlacement: UnitPlacement;
    fileFormat: ExportFileFormat;
};

export function previewColumns(
    columns: ReadonlyArray<PreviewColumnChoice>,
    unitPlacement: UnitPlacement,
    translate: PreviewTranslate,
): ReadonlyArray<FilePreviewColumn> {
    return columns.map(({id, header}) => ({
        id,
        header:
            header ??
            translate(
                exportColumnHeadingKey(id, unitPlacement),
                exportColumnHeadingBundle.application,
                exportColumnHeadingBundle.module,
            ),
    }));
}

export function previewSamples(translate: PreviewTranslate): ReadonlyArray<FilePreviewSample> {
    return sampleMeters.map(meter => {
        const resolved = {...meter};
        for (const columnId of sampleTextColumns) {
            resolved[columnId] = translate(meter[columnId], 'online', 'export');
        }
        return resolved;
    });
}

export function previewContent(
    outputFormat: SavedExportOutputFormat,
    shape: PreviewShape,
    translate: PreviewTranslate,
): FilePreviewContent {
    const fileFormat: ExportFileFormat =
        outputFormat === 'CSV'
            ? shape.fileFormat
            : {...shape.fileFormat, decimalSeparator: 'PERIOD'};
    const input = {
        columns: previewColumns(shape.columns, shape.unitPlacement, translate),
        headerRow: shape.headerRow,
        unitPlacement: shape.unitPlacement,
        samples: previewSamples(translate),
        fileFormat,
    };
    switch (outputFormat) {
        case 'CSV':
            return buildCsvPreview(input);
        case 'EXCEL':
            return buildExcelPreview(input);
        case 'JSON':
            return buildJsonPreview(input);
    }
}
